import bee from "./Bee"
export default {
    name: "Holidays",
    /*
        var query = {
            name:"",
            description:"",
            starts_on: "2020-11-12",
            ends_on: "2020-11-13",
            thumb_nail:"",
            starts_on_timestamp: 0,
            ends_on_timestamp: 0
        }
    */
    /* eslint-disable no-unused-vars */
    post_holiday(query, success, fail) {
        //nyd
        //validate first that holiday periods 
        //and names are not clushing
        var nec = {
            holliday: {
                ...query,
                country_id: 1, //botswana
            }
        };
        bee.post(nec).then(res => {
            if (success) {
                success(res.holliday);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
    /*
        var query = {
            id:0
            name:"",
            description:"",
            starts_on: "2020-11-12",
            ends_on: "2020-11-13",
            thumb_nail:"",
            starts_on_timestamp: 0,
            ends_on_timestamp: 0
        }
    */
    /* eslint-disable no-unused-vars */
    update_holiday(query, success, fail) {
        //nyd
        //validate first that holiday periods 
        //and names are not clushing
        var nec = {
            holliday: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        };
        delete nec.holliday.id;
        bee.update(nec).then(res => {
            if (success) {
                success(res.holliday);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
    /*
        var query = {
            [is_drop_down: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_holidays(query, success, fail) {
        // console.log(query);
        var q = {
            hollidays: {
                _ob: ["starts_on_timestamp"]
            }
        };
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                hollidays: {
                    _a: "id name ",
                    _ob: ["name"]
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.hollidays);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            id:4,
            [is_admin: true],
            [is_edit: true]
        }
    */
    /* eslint-disable no-unused-vars */
    get_holiday(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                holliday: {
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                business_holliday_schedules: {
                    business: {},
                    _w: [
                        ["holliday_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                holliday: {
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.holliday);
                } else if (query.is_admin && query.is_admin == true) {
                    success(res);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
}